<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车辆类型：</span>
        </div>
        <el-select v-model="parkingType" size="small" style="width: 280px">
          <el-option v-for="item in parkingTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" v-if="parkingType !== '3'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="carNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="carOwnerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">车主手机号：</span>
        </div>
        <el-input v-model="carOwnerPhone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">进场时间：</span>
        </div>
        <el-date-picker v-model="carAccessTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" size="small" style="width: 280px"></el-date-picker>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ParkingService'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import InputDatePicker from '../../../components/Input/InputDatePicker'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      InputDatePicker,
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'vehicles-on-site-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'parking-device-management'
          }, {
            value: '在场车辆'
          }],
        },
        mainTitle: '添加在场车辆',
        rentList: [],
        subheading: '',
        personName: '',
        identityNumber: '',
        workType: '',
        certificate: '',

        carOwnerName: '',
        carOwnerPhone: '',
        carNumber: '',
        parkingType: '1',
        carAccessTime: '',

        parkingTypeList: [
          {
            code: '1',
            name: '包月'
          }, {
            code: '2',
            name: '临停'
          }, {
            code: '3',
            name: '无牌'
          }, {
            code: '4',
            name: '白名单'
          }
        ]
      }
    },
    created () {
      this.bindAccountName = bus.global.accountName
      this.bindAccountCode = bus.global.accountCode
    },
    methods: {
      add () {
        if (this.parkingType !== '3' && !this.carNumber) {
          nError('请输入车牌号')
          return false
        }
        let obj = {
          carOwnerName: this.carOwnerName,
          carOwnerPhone: this.carOwnerPhone,
          carNumber: this.carNumber,
          parkingType: this.parkingType,
          carAccessTime: this.carAccessTime
        }
        this.$axios.post(api.addParkingPresentCar, obj)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('添加成功')
              this.strategyCenter()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'vehicles-on-site'
        })
      }
    },
    watch: {
      dataValue (v) {
        this.enterStartTime = v[0]
        this.enterEndTime = v[1]
      },
      parkingType (v) {
        if (v === '3') {
          this.carNumber = ''
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/VehiclesOnSite/VehiclesOnSiteAdd.vue